import {useEffect, useState} from "react";
import lscache from "lscache";

import {USER_REEL_PLAYER_SETTINGS} from "../../app/constants/storage_keys";

interface IPlayerSettings {
    muted: boolean;
}

export const useUserReelPlayerSettingsSync = () => {
    const getPlayerLSSettings = () => {
        const storedSettings = lscache.get(USER_REEL_PLAYER_SETTINGS);

        return {
            muted: storedSettings?.muted ?? true
        };
    };

    const [defaultPlayerSettings, setDefaultPlayerSettings] = useState<IPlayerSettings>(getPlayerLSSettings);

    const refreshPlayerSettings = () => {
        setDefaultPlayerSettings(getPlayerLSSettings());
    };

    useEffect(() => {
        const handleStorageEvent = (event: StorageEvent) => {
            if (event.storageArea === localStorage && event.key?.endsWith(USER_REEL_PLAYER_SETTINGS)) {
                refreshPlayerSettings();
            }
        };

        window.addEventListener("storage", handleStorageEvent);

        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);

    const savePlayerSettings = (settings: IPlayerSettings) => {
        const newSettings = {...defaultPlayerSettings, ...settings};
        lscache.set(USER_REEL_PLAYER_SETTINGS, newSettings);
        setDefaultPlayerSettings(newSettings);
    };

    return {
        defaultPlayerSettings,
        savePlayerSettings,
        refreshPlayerSettings
    };
};
import {useEffect, useState} from "react";
import lscache from "lscache";

import {USER_REEL_PLAYER_SETTINGS} from "../../app/constants/storage_keys";

interface IPlayerSettings {
    muted: boolean;
}

export const useUserReelPlayerSettingsSync = () => {
    const getPlayerLSSettings = () => {
        const storedSettings = lscache.get(USER_REEL_PLAYER_SETTINGS);

        return {
            muted: storedSettings?.muted ?? true
        };
    };

    const [defaultPlayerSettings, setDefaultPlayerSettings] = useState<IPlayerSettings>(getPlayerLSSettings);

    const refreshPlayerSettings = () => {
        setDefaultPlayerSettings(getPlayerLSSettings());
    };

    useEffect(() => {
        const handleStorageEvent = (event: StorageEvent) => {
            if (event.storageArea === localStorage && event.key?.endsWith(USER_REEL_PLAYER_SETTINGS)) {
                refreshPlayerSettings();
            }
        };

        window.addEventListener("storage", handleStorageEvent);

        return () => {
            window.removeEventListener("storage", handleStorageEvent);
        };
    }, []);

    const savePlayerSettings = (settings: IPlayerSettings) => {
        const newSettings = {...defaultPlayerSettings, ...settings};
        lscache.set(USER_REEL_PLAYER_SETTINGS, newSettings);
        setDefaultPlayerSettings(newSettings);
    };

    return {
        defaultPlayerSettings,
        savePlayerSettings,
        refreshPlayerSettings
    };
};
